import { render, staticRenderFns } from "./ShowHearingLossRule.vue?vue&type=template&id=6b6c5dca"
import script from "./ShowHearingLossRule.vue?vue&type=script&lang=js"
export * from "./ShowHearingLossRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports